import React, { useState } from "react";
import { Check, Loader2 } from "lucide-react";
import api from "../../lib/api";
import { UserAvatar } from "../UserAvatar";

/**
 * Riga voce checklist — checkbox 40px (touch target), spunta con transizione
 * 150ms, testo barrato in secondary quando fatta. La spunta altrui mostra
 * il nome accanto alla voce.
 */
export const ChecklistItemRow = ({
  listId, item, canCheck, currentUserId, onChanged,
  ownerActions = null, // nodo opzionale (solo owner): edit/delete/reorder
}) => {
  const [busy, setBusy] = useState(false);
  const done = !!item.done;
  const byOther = done && item.done_by && item.done_by !== currentUserId;

  const toggle = async () => {
    if (!canCheck || busy) return;
    setBusy(true);
    try {
      await api.patch(`/checklists/${listId}/items/${item.id}`, { done: !done });
      await onChanged?.();
    } catch { /* toast gestito a monte se serve */ } finally {
      setBusy(false);
    }
  };

  const time = item.done_at
    ? new Date(item.done_at).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })
    : "";

  return (
    <li className="group flex items-center gap-1 -ml-2" data-testid={`checklist-item-${item.id}`}>
      <button
        type="button"
        onClick={toggle}
        disabled={!canCheck || busy}
        aria-label={done ? "Segna da fare" : "Segna come fatta"}
        data-testid={`checklist-item-toggle-${item.id}`}
        className={`w-10 h-10 flex items-center justify-center shrink-0 rounded-md ${canCheck ? "cursor-pointer hover:bg-subtle" : "cursor-default"} transition-colors duration-150`}
      >
        {busy ? (
          <Loader2 size={16} className="animate-spin text-text-muted" />
        ) : (
          <span
            className={`w-5 h-5 rounded border flex items-center justify-center transition-colors duration-150 ${
              done ? "bg-accent border-accent" : "bg-surface"
            }`}
            style={!done ? { borderColor: "var(--wl-border-strong)" } : undefined}
          >
            {done && <Check size={13} strokeWidth={3} className="text-white" />}
          </span>
        )}
      </button>
      <div className="flex-1 min-w-0 py-1.5">
        <span
          className={`text-sm transition-colors duration-150 ${
            done ? "line-through text-text-secondary" : "text-text-primary"
          }`}
        >
          {item.testo}
        </span>
        {byOther && (
          <span className="ml-2 text-[11px] text-text-muted whitespace-nowrap inline-flex items-center gap-1" data-testid={`item-doneby-${item.id}`}>
            ✓ <UserAvatar userId={item.done_by} name={item.done_by_name} size={14} />
            {item.done_by_name}{time ? ` · ${time}` : ""}
          </span>
        )}
      </div>
      {ownerActions}
    </li>
  );
};
